import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from "react-router-dom";
import "./ResetPassword.scss";
import Footer from './layout/Footer';
import { UserService } from "../services/UserService";
import { ReactComponent as LogoSVG } from "../../node_modules/itd-common/assets/images/brand/logo.svg";
import { AxiosResponse } from "axios";
import CustomReCAPTCHA from "./CustomCaptcha";
import SubmitButton from "./controls/buttons/submitButton";
import Swal from "sweetalert2";
import i18next from "i18next";

interface IProps { }
let DownloadFile: React.FC<IProps> = () => {
    const T_PREFIX: string = 'pages.downloadFile.';
    const { t } = useTranslation();
    const search = useLocation().search;
    const urlParams = new URLSearchParams(search);
    const taskId = urlParams.get("tsk") || '';
    const taskName = urlParams.get("name") || '';
    const [token, setToken] = useState("");
    const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);

    const handleCaptchaVerify = (onVerify: boolean, token: string) => {
        setToken(token);
        setIsCaptchaVerified(onVerify);
    };

    const isSubmitDisabled = () => {
        return !isCaptchaVerified;
    };

    if (!taskId || taskId === '') {
        window.location.href = '/login';
    }
    let downloadExcel = () => {
        if (isCaptchaVerified) {
            UserService.GetFileToDownloadById(taskId, token).then((response: AxiosResponse<any>) => {
                if (response.data.size === 0 || response.status !== 200) {
                    Swal.fire({
                        html: i18next.t("settlementsDownloadFileNotification"),
                        confirmButtonColor: '#f60'
                    });
                } else {
                    // @ts-ignore
                    let outputFilename = response.headers['content-disposition']
                        .split(';')
                        .find((n: any) => n.includes('filename='))
                        .replace('filename=', '')
                        .trim();
                    const url = URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', outputFilename);
                    link.click();
                }
            }).catch(error => {
                console.log('error:', error);
            });
        }
    }
    return (
        <React.Fragment>
            <div className="page forgot-key">
                <div className="container-forgot">
                    <div className="form">
                        <div className='row'>
                            <div className='col-md-5'>
                                <div className="backward">
                                    <div className="backward__init">
                                        <Link to={'/login'} className="link">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g id="ico/arrow-left">
                                                    <path id="Vector 1" d="M10 4L2 12L10 20" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    <line id="Line 7" x1="3" y1="12" x2="21" y2="12" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                </g>
                                            </svg>
                                            <span className='backward__init__callback'>{t(`${T_PREFIX}returnToLogin`)}</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='brand-logo-container mt-4'>
                            <LogoSVG className='brand-logo-container__image' ></LogoSVG>
                        </div>
                        <span className="login100-form-title pb-4 wrapText mt-4">
                            {taskName}
                        </span>
                        <div>
                            <div className='confirmForgotPass row' >
                                <div className="col-md-12">
                                    <CustomReCAPTCHA useCache={false} onVerify={handleCaptchaVerify} />
                                </div>
                            </div>
                            <div>
                                <div className="boton col-md-12">
                                    <div className="boton__click">
                                        <SubmitButton className="mb-4 envio"
                                            onClick={() => downloadExcel()}
                                            disabled={isSubmitDisabled()}>
                                            <div className='submit-button-container'>
                                                <span className='ms-3' >{t(`${T_PREFIX}button`)}</span>
                                            </div>
                                        </SubmitButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer isValid={false} />
        </React.Fragment>
    )
}
export default DownloadFile